<template>
  <div>
    <div class="footer-padding"></div>
    <footer>
      <div class="center-wrapper">
        <footer-block
          title="PFX"
          :items="[
            ['About PFX', '/about', false, true],
            ['Terms of Use', '/terms', false, true],
            ['Broker Registration Terms', '/broker', false, true],
            ['Privacy Policy', '/privacy', false, true],
            ['Current Auctions', '/listings', false, true],
          ]"
        />
        <footer-block
          title="Brokers"
          :items="[
            ['Sign-Up', '/about/for-brokers', false, true],
          ]"
        />
        <footer-block
          title="Help"
          :items="[
            ['Help Center', '/faq', false, true],
            //['Tutorial', '#', false],
            //['Get Started', '#', false],
          ]"
        />
        <footer-block
          title="Follow Us"
          :items="[
            ['LinkedIn', 'https://www.linkedin.com/company/pfx-inc', true, true],
            ['Facebook', 'https://www.facebook.com/PFX-276204666200209/', true, true],
          ]"
        />
        <footer-block
          title="Contact Us"
          :items="[
            ['PFX Inc., 1111 North Brand Boulevard, Suite 200, Glendale, California 91202', '', false, false],
            ['US Phone: 855-949-3800', '', false, false],
            ['e-Mail: contact@pfxinc.com', 'pfx@pfxinc.com', false, false]
          ]"
        />
        <p class="copyright-info">
          <a :href="pfxLandingPageUrl">© PFX {{ year }} <span></span> Powered by PFX Commercial Real Estate e-auction platform</a>
        </p>
      </div>
      <!-- Cookie alert banner -->
      <vue-cookie-accept-decline
        :ref="'MainFooter'"
        :elementId="'MainFooter'"
        :debug="false"
        :position="'bottom'"
        :type="'bar'"
        :disableDecline="true"
        :transitionName="'slideFromBottom'"
        :showPostponeButton="false">
        @status="cookieStatus"
        @clicked-accept="cookieClickedAccept"
        @clicked-decline="cookieClickedDecline">

        <div slot="message">
          By continuing to use our site, you agree to our Terms of Use and Privacy Policy. You can learn more about how we use cookies by reviewing our Privacy Policy <span></span><router-link to="/privacy" class="alt-link-cookie-banner">click here</router-link>.
        </div>

        <div slot="acceptContent">
          Got it!
        </div>
      </vue-cookie-accept-decline>
    </footer>
  </div>
</template>

<script>
  import FooterBlock from './FooterBlock.vue'
  import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
  import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

  export default {
    name: 'MainFooter',
    components: {
      FooterBlock,
      VueCookieAcceptDecline
    },
    data() {
      return {
        pfxLandingPageUrl: process.env.config.frontend.pfxLandingPage,
        year: new Date().getFullYear()
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../pfx.scss';

  // Overrides the vue-cookie-accept-decline color attributes
  .cookie {
    background: #707070 !important;
    box-shadow: 0 -4px 4px #707070 !important;
    color: #FBFBFA;
  }

  .copyright-info {
    font-size: 12px;
    margin-top: 100px;
    @include column(1);
    text-align: center;
    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
      span {
        margin: 0 6px;
      }
    }
  }
  .center-wrapper {
    @include center(800px);
    width: 90%;
  }
  footer {
    @include clearfix();
    width: 100%;
    padding: 44px 0 64px;
    background-color: #FBFBFA;
  }
  footer, footer a {
    color: #000;
  }

  // Setting "click hear" text color
  .alt-link-cookie-banner {
    text-decoration: underline;
    color: white;
    &:hover {
      text-decoration: underline;
      color: blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/MainFooter.vue